import { PageHeader } from "../../components/ui/page-header";
import { Button } from "../../components/ui/button";
import { navigate, usePreviousPage } from "../../lib/router";
import { useLanguage } from "../../hooks/useLanguage";

type PageBuilderHeaderProps = {
  isEditing: boolean;
  onSave?: () => void;
  saving?: boolean;
  hasUnsavedChanges?: boolean;
};

export function PageBuilderHeader({ isEditing, onSave, saving, hasUnsavedChanges }: PageBuilderHeaderProps) {
  const { t } = useLanguage();
  const previousPage = usePreviousPage();

  // Determine where to go back based on previous page
  const getBackDestination = () => {
    if (previousPage === "/app") {
      return "/app";
    }
    // If coming from page details, go back to details
    if (previousPage?.startsWith("/app/detalhes/")) {
      return previousPage;
    }
    // Default fallback
    return "/app";
  };

  const handleBack = () => {
    if (hasUnsavedChanges) {
      const confirmed = window.confirm(
        t.pageBuilder.header.unsavedChanges
      );
      if (!confirmed) return;
    }
    navigate(getBackDestination());
  };

  const saveButton = onSave && (
    <Button
      variant={hasUnsavedChanges ? undefined : "primary"}
      onClick={onSave}
      disabled={saving}
      className={hasUnsavedChanges ? "bg-amber-600 hover:bg-amber-700 text-white rounded-xl" : ""}
    >
      {saving
        ? t.pageBuilder.toast.saving
        : isEditing
        ? t.pageBuilder.linkModal.save
        : t.pageBuilder.linkModal.add}
    </Button>
  );

  return (
    <PageHeader
      label={isEditing ? t.pageBuilder.header.title : t.pageBuilder.header.newPageTitle}
      title={isEditing ? t.pageBuilder.header.subtitle : t.pageBuilder.header.newPageSubtitle}
      onBack={handleBack}
      actions={saveButton}
      showUnsavedChanges={hasUnsavedChanges}
    />
  );
}
